<div class="modal-wrapper">
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-basic-title"
      i18n="@@document.list.rejection.reject"
    >
      Reject
    </h4>
    <i class="fas fa-times" (click)="onClose()"></i>
  </div>
  <div class="modal-body">
    <div class="card">
      <div class="card-title" i18n="@@document.list.rejection.rejectername">
        Rejecter name
      </div>
      <div class="md-form form-group">
        <input
          class="form-control"
          type="text"
          placeholder="Name Lastname"
          [readonly]="readonly"
          [(ngModel)]="name"
        />
      </div>
    </div>
    <div class="card remarks-container">
      <div class="card-title" i18n="@@document.list.rejection.reason">
        Reason for rejection
      </div>
      <textarea
        placeholder="Add remarks"
        maxlength="3000"
        [readonly]="readonly"
        [(ngModel)]="remarks"
      ></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button
      *ngIf="!readonly"
      [disabled]="!canSave"
      class="save-button"
      (click)="onSave()"
    >
      <img src="assets/Keen&Wise_save_transparant.png" />
    </button>
  </div>
</div>
